import { useTranslation } from '@utils';
import FieldLabel from '@components/form/field-label';
import PropTypes from 'prop-types';
import React from 'react';
import ReasonChip from './reason-chip';

const ReasonChips = ({
  reasons, selected, mandatory, onToggle,
}) => {
  const getTranslation = useTranslation();

  return (
    <div>
      <div className="mb-1.5">
        <FieldLabel name={getTranslation('FEEDBACK_SELECT_REASON_LABEL')} mandatory={mandatory} className="break-words" />
      </div>
      <div className="feedback-reason-chips flex flex-wrap gap-2">
        {reasons.map((reason) => (
          <ReasonChip
            key={reason.slot}
            label={reason.text}
            slot={reason.slot}
            selected={selected.includes(reason.slot)}
            onToggle={onToggle}
          />
        ))}
      </div>
    </div>
  );
};

ReasonChips.propTypes = {
  reasons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    slot: PropTypes.number,
  })).isRequired,
  // Slots (BE positions) of the selected reasons.
  selected: PropTypes.arrayOf(PropTypes.number).isRequired,
  mandatory: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

ReasonChips.defaultProps = {
  mandatory: false,
};

export default ReasonChips;
